import { StatusMessage } from "./useBintactMapCommunication";

interface BintactStatusMessageProps {
  statusMessage: StatusMessage | null;
  showContainer?: boolean;
  margin?: "left" | "top";
}

const BintactStatusMessage = ({
  statusMessage,
  showContainer = true,
  margin = "left",
}: BintactStatusMessageProps) => {
  if (!statusMessage) {
    return null;
  }

  const messageContent = (
    <div
      style={{
        padding: "8px 16px",
        borderRadius: "4px",
        border: `1px solid ${statusMessage.borderColor}`,
        backgroundColor: statusMessage.backgroundColor,
        color: statusMessage.color,
        fontSize: "14px",
        fontWeight: 500,
        display: "flex",
        alignItems: "center",
        height: "100%",
        maxWidth: "400px",
        wordWrap: "break-word",
        marginLeft: margin === "left" ? "1rem" : undefined,
        marginTop: margin === "top" ? "0.5rem" : undefined,
      }}
    >
      {statusMessage.text}
    </div>
  );

  if (!showContainer) {
    return messageContent;
  }

  return (
    <div
      className="builder-main-tabs ps-3 pb-2 gap-8 ms-2"
      style={{ borderBottom: "none" }}
    >
      {messageContent}
    </div>
  );
};

export default BintactStatusMessage;

